import BigNumber from "bignumber.js";

export const sum = collection => collection.reduce((sum, item) => sum.plus(item || 0), new BigNumber(0));